/**
 * Hook to fetch active payment methods from company settings.
 * Falls back to hardcoded defaults if the API call fails.
 */
import { useState, useEffect } from 'react';
import { adminService, PaymentMethodOption } from '../services';

const DEFAULTS: PaymentMethodOption[] = [
  { code: 'ESPECES', label: 'Espèces', active: true },
  { code: 'CHEQUE', label: 'Chèque', active: true },
  { code: 'VIREMENT', label: 'Virement bancaire', active: true },
  { code: 'MOBILE_MONEY_MTN', label: 'Mobile Money MTN', active: true },
  { code: 'MOBILE_MONEY_MOOV', label: 'Mobile Money Moov', active: true },
];

// Module-level cache to avoid fetching on every mount
let cachedMethods: PaymentMethodOption[] | null = null;
let cacheTime = 0;
const CACHE_TTL = 5 * 60 * 1000; // 5 minutes

export function usePaymentMethods() {
  const [methods, setMethods] = useState<PaymentMethodOption[]>(cachedMethods || DEFAULTS);

  useEffect(() => {
    if (cachedMethods && Date.now() - cacheTime < CACHE_TTL) return;
    adminService.getPaymentMethods()
      .then(data => {
        cachedMethods = data;
        cacheTime = Date.now();
        setMethods(data);
      })
      .catch(() => {
        // Fallback to defaults silently
      });
  }, []);

  return methods;
}
